import { getLocalApiUrl } from '../config/api'

const SCENE_PHOTO_PATH = '/api/mobile/incidents/scene-photo'

/** Rewrite signed scene-photo proxy URLs to the SPA's API origin (fixes internal Host in JSON). */
export function normalizeScenePhotoApiUrl(url) {
  if (!url || typeof url !== 'string') return url
  if (url.startsWith('data:')) return url
  try {
    const u = new URL(url, typeof window !== 'undefined' ? window.location.origin : 'https://localhost')
    if (u.pathname.includes(SCENE_PHOTO_PATH)) {
      return getLocalApiUrl(`${u.pathname}${u.search}`)
    }
    if (url.startsWith('http://') && typeof window !== 'undefined' && window.location.protocol === 'https:') {
      return url.replace(/^http:\/\//i, 'https://')
    }
  } catch {
    /* ignore */
  }
  return url
}

/** Blob ref from mobile_capture_json / incident attachments ({ url } or legacy base64). */
export function blobPreviewUrl(ref, mime = 'image/jpeg') {
  if (!ref) return null
  if (typeof ref === 'string' && ref.length > 0) {
    if (ref.startsWith('data:')) return ref
    if (ref.startsWith('http')) return normalizeScenePhotoApiUrl(ref)
    return getLocalApiUrl(ref)
  }
  if (typeof ref !== 'object') return null
  if (ref.retention_removed === true) return null
  if (typeof ref.url === 'string' && ref.url.length > 0) {
    const u = ref.url
    if (u.startsWith('data:')) return u
    if (u.startsWith('http')) return normalizeScenePhotoApiUrl(u)
    return getLocalApiUrl(u)
  }
  const b64 = ref.image_base64 || ref.photo_jpeg_base64 || ref.data
  if (typeof b64 === 'string' && b64.length > 0) {
    return b64.startsWith('data:') ? b64 : `data:${mime};base64,${b64}`
  }
  return null
}
